import { NativeDateAdapter } from "@angular/material/core";

export class CustomDateAdapter extends NativeDateAdapter {
  // Start from Monday
  getFirstDayOfWeek(): number {
    return 1;
  }
}
